const googleSheetScriptUrl = 'https://script.google.com/macros/s/AKfycbzIvWcOpR1rqKE8tvVQkLYuzfeTI2jv1eU5l-xfbGKrTJ5Ev_NhVrV497_LkcWgrZCuug/exec';

export const saveBookingDemoData = async (values: any) => {
    const bookingData = {
        FirstName: values.firstName ?? '',
        LastName: values.lastName ?? '',
        JobTitle: values.jobTitle ?? '',
        Email: values.email ?? '',
        Phone: (values.phone ?? '').replace(/ +/g, ''),
        CompanyName: values.companyName ?? '',
        SelectedDate: values.selectedDate ?? '2025-07-21',
        SelectedEgyptTimeSlot: values.selectedEgyptTimeSlot ?? '10:00',
        ReceiveEmails : values.receiveEmails === true ? 'Yes' : 'No'
    };

    const res = await fetch(googleSheetScriptUrl, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: `FirstName=${encodeURIComponent(bookingData.FirstName)}&LastName=${encodeURIComponent(bookingData.LastName)}&JobTitle=${encodeURIComponent(bookingData.JobTitle)}&Email=${encodeURIComponent(bookingData.Email)}&Phone=${encodeURIComponent(bookingData.Phone)}&CompanyName=${encodeURIComponent(bookingData.CompanyName)}&SelectedDate=${encodeURIComponent(bookingData.SelectedDate)}&SelectedEgyptTimeSlot=${encodeURIComponent(bookingData.SelectedEgyptTimeSlot)}&ReceiveEmails=${encodeURIComponent(bookingData.ReceiveEmails)}`
    }).catch(err=>{console.log(err)});
    return res
};

export const getBookingDemoData = async () => {
    const res = await fetch(googleSheetScriptUrl, {
        method: 'GET'
    }).catch(err => {
        console.log(err);
    });

    if (!res || !res.ok) {
        return null;
    }

    return res.json();
};